import Loader from '@/components/Loader.tsx';
import { RoutesEnum } from '@/routes/Routes.enum.ts';
import { useGetCurrentUser } from '@/hooks/useGetCurrentUser.tsx';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface AppInitializerProps {
  children: React.ReactNode;
}

const AppInitializer: React.FC<AppInitializerProps> = ({ children }) => {
  const location = useLocation();
  if (location.pathname === RoutesEnum.ADMIN_LOGIN) {
    return <AdminLoginInitializer>{children}</AdminLoginInitializer>;
  }
  return <FullInitializer>{children}</FullInitializer>;
};

const AdminLoginInitializer: React.FC<AppInitializerProps> = ({ children }) => {
  const { setIsInitialized } = useUserContext();

  useEffect(() => {
    setIsInitialized(true);
  }, [setIsInitialized]);

  return <>{children}</>;
};

const FullInitializer: React.FC<AppInitializerProps> = ({ children }) => {
  const { setIsInitialized, setUser } = useUserContext();
  const { currentUser, error, isLoading } = useGetCurrentUser();

  useEffect(() => {
    if (currentUser) {
      setUser(currentUser);
      setIsInitialized(true);
    }
    if (error) {
      setIsInitialized(true);
    }
  }, [currentUser, setIsInitialized, setUser, error]);

  if (isLoading) {
    return <Loader className="min-h-dvh" />;
  }

  return <>{children}</>;
};

export default AppInitializer;
